export default __webpack_public_path__ + "static/media/abyss home.bd6a9360.jpg";